module.exports = __webpack_public_path__ + "img/activity3_2024.be1c5d57.png";